module.exports = __webpack_public_path__ + "static/media/fcpsr.68ff40c3.jpg";